<template>
    <form :action="action" :method="method" @submit.prevent="onFormSubmit" :id="status.formId">
        <slot v-bind:model="{vals:modelStore, status:status}" v-bind:disabled="status.disabled">
        <!-- form components can be placed in the default slot.
        They work the same as a regular input tag, only you use:
        v-model="model.name" instead of name="name"
        You need to pull the model into the slot scope with:
        v-slot="{model}"
        on the markup.
        -->
        </slot>

        <div v-if="status.errors.length" class="ajax-error-alert error-display alert alert-danger">
            <ul class="mb-0">
                <li v-for="(value, key) in status.errors" :key="key">{{value}}</li>
            </ul>
        </div>

        <div class="form-group row">
            <div class="col-xs-6 pr-1 pl-3" style="width:50%">
                <button type="submit"
                    :class="{'btn-success':status.successNotify}"
                    class="form-control btn btn-primary"
                    :disabled="status.disabled"
                >
                        <span v-if="status.successNotify" class="icon-ok-circle"> Success</span>
                        <span v-else-if="status.disabled" class="icon-clock">{{processing_text}}</span>
                        <span v-else>{{submit_text}}</span>
                </button>
            </div>
            <div class="col-xs-6 pl-1 pr-3" style="width:50%">
                <button type="button" class="form-control btn btn-secondary form-cancel"
                    @click="onFormCancel"
                    :disabled="status.disabled">{{cancel_text}}</button>
            </div>
        </div>

    </form>

</template>

<script>

import componentMixin from './component-mixin.js'

export default {
    mixins:[
        componentMixin
    ],
    props:{
        submit_text:{
            type:String,
            default:"Submit",
        },
        cancel_text:{
            type:String,
            default:"Cancel",
        },
        processing_text:{
            type:String,
            default:"Processing...",
        },
        method:{
            type:String,
            default:"POST",
        },
        action:String,
        hiddenInput:{
            type:Object,
            default:()=>{return {};},
        },
        modelSrc:{
            type:Object,
            default:()=>{return {};},
        },
        modelStoreIsolated:{
            type:Boolean,
            default:false,
        },
    },
    data(){
        return {
            status:{
                errors:[],
                validationErrors:[],
                disabled:false,
                successNotify:false,
                formId:this.makeRandomId(),
            },
            modelStore:{},
        }
    },
    mounted(){
        if (!this.modelStoreIsolated){
            this.modelStore = JSON.parse(JSON.stringify(this.modelSrc)); // json is used to deep copy the modelSrc into model.
        }
    },

    methods:{
        onFormCancel: function(){
            // restore original content from modelSrc on cancel.
            this.modelStore = JSON.parse(JSON.stringify(this.modelSrc)); // json is used to deep copy the modelSrc into model.
            this.$emit('cancel');
        },
        onFormSubmit: function(){
            var formData = {...this.modelStore, ...this.hiddenInput}

            this.status.disabled = true;
            this.status.errors = [];
            this.$emit('pre-submit');
            axios[this.method.toLowerCase()](this.action, formData)
            .then((response) => {
                this.status.successNotify = true;
                this.$emit('success', response.data);
                window.setTimeout(()=>{
                    this.status.disabled = false;
                    this.status.successNotify = false;
                    this.$emit('success-complete', response.data);
                }, 3000)
            })
            .catch((error) => {
                if (error.response.status == 422){ // validation error

                    Object.values(error.response.data.errors).forEach((val)=>{
                        val.forEach((inner)=>{
                            this.status.errors.push(inner);
                        });
                    });
                    this.status.validationErrors = error.response.data.errors;

                } else {

                    this.status.errors.push(error.message);
                    console.log(error.response);

                }
                this.status.disabled = false;
            });
        },

    },
    computed:{
    },
    watch: {
        modelSrc: function(newVal, oldVal) { // watch it
            // if we have not isolated the internal model store, then update it from the modelSrc
            if (!this.modelStoreIsolated){
                this.modelStore = JSON.parse(JSON.stringify(this.modelSrc)); // json is used to deep copy the modelSrc into model.
            }

        },
    }

}
</script>
